import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { parseRmaReasonDTOList, RmaReasonDTO } from 'components/ordering/rma/api/dtos/rma-reason-dto.js'

export class GetRmaReasons extends RmaRequest<RmaReasonDTO[], never> {
  path = 'account/rma/reasons/'

  override parseResponse = (data: unknown) =>
    parseRmaReasonDTOList((data as { results: unknown }).results)
}
